import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { show, hide } from "redux-modal";
import { ButtonClose } from "./style";
import EvalForm from "../evaluationEvalForm";
import NotifiedForm from "../notifiedEvalForm";
import * as EvaluationServices from "../../../../services/EvaluationServices";
import showDialog from "../../../utils/ShowDialog/ShowDialog";
import { useNavigate } from "react-router-dom";
import PATHS from "../../../../constants/paths";

export const useEvaluations = (refresh) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handlerClosePopup = (popupName) => {
    dispatch(hide(popupName));
  };

  // const completeEval = async (data) => {
  //   dispatch(
  //     show("ModalForm", {
  //       body: (
  //         <>
  //           <div className="row mb-3">
  //             <div className="col-12 text-end">
  //               <ButtonClose
  //                 type="button"
  //                 onClick={() => handlerClosePopup("ModalForm")}
  //               >
  //                 <i className="fa-solid fa-xmark"></i>
  //               </ButtonClose>
  //             </div>
  //           </div>
  //           <div className="row">
  //             <div className="col-12">
  //               <EvalForm
  //                 finalEval
  //                 onCancel={() => handlerClosePopup("ModalForm")}
  //                 onSuccess={() => {
  //                   handlerClosePopup("ModalForm");
  //                   if (refresh) {
  //                     refresh();
  //                   }
  //                 }}
  //                 evaluation={data}
  //               ></EvalForm>
  //             </div>
  //           </div>
  //         </>
  //       ),
  //     })
  //   );
  // };

  const confirmAutoEval = async (data) => {
    const result = await EvaluationServices.confirmAutoEvaluation(data.uuid);
    if (result) {
      const okAction = () => {
        if (refresh) {
          refresh();
        }
      };
      showDialog(
        t("forms.evaluation.message.autoEval.title"),
        t("forms.evaluation.message.autoEval.text"),
        "success",
        false,
        "OK",
        false,
        okAction
      );
    }
  };

  const completeAutoEval = async (data) => {
    try {
      const okAction = () => {
        confirmAutoEval(data);
      };
      const cancelAction = () => {
        // saveAutoEvaluation(values);
      };
      showDialog(
        t("forms.evaluation.dialog.saveAutoEval.title"),
        t("forms.evaluation.dialog.saveAutoEval.text"),
        "question",
        true,
        t("forms.evaluation.dialog.saveAutoEval.buttonOk"),
        false,
        okAction,
        t("forms.evaluation.dialog.saveAutoEval.buttonNo"),
        cancelAction
      );
    } catch (error) {
      // console.log("Error", error);
    }

    // dispatch(
    //   show("ModalForm", {
    //     body: (
    //       <div>
    //         <div className="row mb-3">
    //           <div className="col-12 text-end">
    //             <ButtonClose
    //               type="button"
    //               onClick={() => handlerClosePopup("ModalForm")}
    //             >
    //               <i className="fa-solid fa-xmark"></i>
    //             </ButtonClose>
    //           </div>
    //         </div>
    //         <div className="row">
    //           <div className="col-12">
    //             <EvalForm
    //               onCancel={() => handlerClosePopup("ModalForm")}
    //               onSuccess={() => {
    //                 handlerClosePopup("ModalForm");
    //                 if (refresh) {
    //                   refresh();
    //                 }
    //               }}
    //               evaluation={data}
    //             ></EvalForm>
    //           </div>
    //         </div>
    //       </div>
    //     ),
    //   })
    // );
  };

  const notifiedEval = async (data) => {
    dispatch(
      show("ModalForm", {
        body: (
          <>
            <div className="row mb-3">
              <div className="col-12 text-end">
                <ButtonClose
                  type="button"
                  onClick={() => handlerClosePopup("ModalForm")}
                >
                  <i className="fa-solid fa-xmark"></i>
                </ButtonClose>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <NotifiedForm
                  finalEval
                  onCancel={() => handlerClosePopup("ModalForm")}
                  onSuccess={() => {
                    handlerClosePopup("ModalForm");
                    if (refresh) {
                      refresh();
                    }
                  }}
                  evaluation={data}
                ></NotifiedForm>
              </div>
            </div>
          </>
        ),
      })
    );
  };

  const saveUnitObjective = async (values, dataEval, isManager = false) => {
    try {
      // if (comments && comments.length > 0) {
      //   values.comments = comments;
      // }
      let result = null;
      if (isManager) {
        result = await EvaluationServices.setManagerUnitObj(values, dataEval);
      } else {
        result = await EvaluationServices.setAutoUnitObj(values, dataEval);
      }

      if (result) {
        const okAction = () => {
          if (refresh) {
            refresh();
          }
        };
        showDialog(
          t(
            `forms.evaluation.message.${isManager ? "eval" : "autoEval"}.title`
          ),
          t(`forms.evaluation.message.${isManager ? "eval" : "autoEval"}.text`),
          "success",
          false,
          "OK",
          false,
          okAction
        );
      }
    } catch (error) {
      // console.log("Error", error);
    }
  };

  const completeEval = async (data) => {
    try {
      const okAction = () => {
        confirmEval(data);
      };
      const cancelAction = () => {
        // saveAutoEvaluation(values);
      };
      showDialog(
        t("forms.evaluation.dialog.confirm.title"),
        t("forms.evaluation.dialog.confirm.text"),
        "question",
        true,
        t("forms.evaluation.dialog.confirm.buttonOk"),
        false,
        okAction,
        t("forms.evaluation.dialog.confirm.buttonNo"),
        cancelAction
      );
    } catch (error) {
      // console.log("Error", error);
    }
  };

  const confirmEval = async (data) => {
    const result = await EvaluationServices.confirmManagerEvaluation(data.uuid);
    if (result) {
      const okAction = () => {
        if (refresh) {
          navigate(PATHS.EVALUATION);
        }
      };
      showDialog(
        t("forms.evaluation.message.eval.title"),
        t("forms.evaluation.message.eval.text"),
        "success",
        false,
        "OK",
        false,
        okAction
      );
    }
  };

  return {
    completeAutoEval,
    completeEval,
    notifiedEval,
    saveUnitObjective,
  };
};
